import { Link } from 'react-router-dom'

export default function RegisterFooter() {
  return (
    <div>
      <p>
        <span>Signing up for a Profit Flow account means you agree to the</span>{' '}
        <Link to="/privacy-policy" className="text-txt-secondary">
          Privacy Policy
        </Link>{' '}
        and{' '}
        <Link to="terms-of-service" className="text-txt-secondary">
          Terms of Service
        </Link>
      </p>

      <p>
        Have an account? <Link to="/login">Sign in</Link>
      </p>
    </div>
  )
}
